<template>
  <v-container
    class="organizations-view fill-height"
    fluid
  >
    <v-row>
      <v-col cols="12">
        <v-row
          align="center"
          justify="center"
          class="company-container fill-height"
        >
          <v-col
            md="5"
            lg="4"
            xl="3"
          >
            <StLogo link="https://warroom.stilingue.com.br" />
            <v-card class="company-container__card">
              <v-card-title
                primary-title
                class="pl-6"
              >
                <h3>{{ pageTitle }}</h3>
              </v-card-title>
              <v-card-actions>
                <v-list class="company-container__card__list px-3">
                  <v-list-item
                    v-for="company in companies"
                    :key="company.name"
                    class="company-container__card__list-item elevation-1"
                    @click="onClick(company)"
                  >
                    <v-list-item-content>
                      {{ company.name }}
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import StLogo from '@stilingue/st-logo';

export default {
  name: 'StCompanySelection',
  components: {
    StLogo,
  },
  props: {
    companies: {
      type: Array,
      required: true,
    },
    pageTitle: {
      type: String,
      default: '',
    },
  },
  methods: {
    onClick(company) {
      this.$emit('selected', company);
    },
  },
};
</script>

<style scoped lang="scss">
  .organizations-view {
    background-color: var(--gray-050);
  }

  .company-container {
    &__card * {
      background-color: var(--gray-100);
      color: var(--white);
    }

    &__card__list {
      padding-top: 0;
      width: 100%;
    }

    ::v-deep {
      .logo-container {
        display: inline-block;
        margin-bottom: 20px;
        margin-left: 50%;
        transform: translateX(-50%);
      }

      .company-container__card__list-item {
        border-radius: 3px;
        width: 100%;
        height: 51px;
        margin-bottom: 5px;
        transition: none;

        .v-list__item--link {
          transition: none !important;
        }

        &:hover,
        &:hover * {
          background-color: var(--gray-050) !important;
          color: var(--white);
        }
      }
    }
  }

</style>
